// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose, withHandlers } from '../../../../../../../node_module_clones/recompose';

// Utils
import { getGroupId, getGroupNotifications, getGroupTitle } from '../../groups/notificationGroupUtils';
import { createQueryString } from '../../../../../../../common/utils/stringUtil';
import { getNotificationId } from '../../../../../../../common/notifications/notificationModelUtils';

// Selector
import { getCurrentBoardId } from '../../../../../../reducers/currentBoardId/currentBoardIdSelector';

// Actions
import { markNotificationsAsSeen } from '../../../../../../notifications/notificationActions';

// Components
import BaseNotificationGroup from './BaseNotificationGroup';
import Icon from '../../../../../../components/icons/Icon';

// Styles
import './NotificationGroupTemplate.scss';

const getTemplateUrl = ({ group, currentBoardId }) => {
    const collectionId = getGroupId(group);

    const queryString = createQueryString({
        filter_ids: collectionId,
        filter_context: 'template',
    });

    return `/${currentBoardId}?${queryString}`;
};

const mapDispatchToProps = (dispatch) => ({
    dispatchMarkNotificationsAsSeen: (notificationIds) => dispatch(markNotificationsAsSeen(notificationIds)),
});

const mapStateToProps = createStructuredSelector({
    currentBoardId: getCurrentBoardId,
});

const handlers = {
    onClick:
        ({ group, dispatchMarkNotificationsAsSeen }) =>
        (event) => {
            if (!group) return;

            const groupNotifications = getGroupNotifications(group);
            const notificationIds = groupNotifications.map(getNotificationId);
            dispatchMarkNotificationsAsSeen(notificationIds);
        },
};

const enhance = compose(connect(mapStateToProps, mapDispatchToProps), withHandlers(handlers));

const NotificationGroupTemplate = (props) => {
    const { group } = props;

    const title = getGroupTitle(group);
    const url = getTemplateUrl(props);

    return (
        <BaseNotificationGroup
            {...props}
            className="NotificationGroupTemplate"
            figure={<Icon name="old-notification-template" />}
            text={title}
            url={url}
        />
    );
};

NotificationGroupTemplate.propTypes = {
    group: PropTypes.object,
    currentBoardId: PropTypes.string,
};

export default enhance(NotificationGroupTemplate);
